import { onBeforeUnmount } from 'vue';
import { t } from '../../locales/index';

const secondsPeriods = [
	{
		seconds: 31104000,
		key: 'dates.year',
		shortKey: 'dates.short.year',
	},
	{
		seconds: 2592000,
		key: 'dates.month',
		shortKey: 'dates.short.month',
	},
	{
		seconds: 86400,
		key: 'dates.day',
		shortKey: 'dates.short.day',
	},
	{
		seconds: 3600,
		key: 'dates.hour',
		shortKey: 'dates.short.hour',
	},
	{
		seconds: 60,
		key: 'dates.min',
		shortKey: 'dates.short.min',
	},
];
export const dateSinceFormatter = (date, { short } = { short: false }) => {
	if (typeof date === 'string') date = new Date(date);

	const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

	if (seconds <= 59) return short ? t('dates.short.just-now') : t('dates.just-now');

	for (let i = 0; i < secondsPeriods.length; i++) {
		const period = secondsPeriods[i];
		if (seconds >= period.seconds) {
			const cnt = Math.floor(seconds / period.seconds);
			return `${cnt} ${t(short ? period.shortKey : period.key, cnt)}`;
		}
	}
};

export const periodOptions = [
	{
		id: 1,
		label: t('dates.current-year'),
		from: () => moment().startOf('year').toDate(),
		to: () => moment().endOf('year').toDate(),
	},
	{
		id: 2,
		label: t('dates.current-month'),
		from: () => moment().startOf('month').toDate(),
		to: () => moment().endOf('month').toDate(),
	},
];

export const useInterval = (cb, ms = 1000) => {
	const id = setInterval(cb, ms);

	onBeforeUnmount(() => {
		clearInterval(id);
	});
};

export const isToday = (date) => {
	if (!date) return false;
	const today = new Date();
	date = new Date(date);
	return (
		date.getDate() == today.getDate() &&
		date.getMonth() == today.getMonth() &&
		date.getFullYear() == today.getFullYear()
	);
};

export const isYesterday = (date) => {
	if (!date) return false;
	const yesterday = new Date();
	yesterday.setDate(yesterday.getDate() - 1);
	date = new Date(date);
	return (
		date.getDate() == yesterday.getDate() &&
		date.getMonth() == yesterday.getMonth() &&
		date.getFullYear() == yesterday.getFullYear()
	);
};
